<div class="container-fluid">
    <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif">
    </div>
</div>
<div class="row mar-lft-rgt-0">
    <div class="col-md-12 pad-15">
        <div class="height-40" [hidden]="categoryLoaded">
            <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
        </div>
        <select class="custom-select  tcktyp" *ngFor="let ticket of ticketTypes;" [disabled]="ticket.isDisabled"
            (change)="onCategoryChange(ticket,$event.target.value)" id="ticket1_{{ticket.id}}"
            [hidden]="!categoryLoaded">
            <option *ngFor="let option of ticket.options" [value]="option|json">{{option.title}}</option>
        </select>
    </div>
</div>

<div class="row mar-lft-rgt-0">
    <div class="form-group col-md-2" *ngFor="let field of dynamicFields;" [ngSwitch]="field.fieldType"
        [ngClass]="field.type==='child'?'child none':''">
        <input *ngSwitchCase="'1'" type="text" class="form-control radius-0 font-13 no"
            placeholder="{{field.fieldName}}" [(ngModel)]="field.value">
        <mat-form-field *ngSwitchCase="'4'">
            <mat-label>{{field.fieldName}}</mat-label>
            <mat-select [(ngModel)]="field.value">
                <mat-option *ngFor="let opt of field.values" [value]="opt">{{opt}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
<div class="row mar-lft-rgt-0">

    <div class="col-md-12 ">
        <div class="row mar-top-9">
            <div class="form-group col-md-6">
                <input type="text" class="form-control radius-0 font-13 "
                    placeholder="Enter Requester info (Ex. Name, phone number , email etc)" [(ngModel)]="name"
                    title="{{name}}" readonly [ngClass]="isBlankRequester?'error-field':''">

            </div>
            <div class="form-group col-md-6 row mar-lft-rgt-0" *ngIf="priorityType===2" [hidden]="isLowestLevel ">
                <p class="col-sm-2 custom-label pad-lft-0">Priority</p>
                <div class="col-sm-10">
                    <input class="form-control radius-0 font-13 " type="text" [(ngModel)]="priority"
                        placeholder="Priority" readonly [ngClass]="isBlankPriority?'error-field':''">
                </div>
            </div>
        </div>
        <div class="form-group">
            <input type="text" class="form-control radius-0 font-13" placeholder="Ticket Title" [(ngModel)]="desc"
                maxlength="50" (input)="searchFaq($event.target.value)" [ngClass]="isBlankDesc?'error-field':''">
            <div class="warning-msg">
                *maximum 50 characters
            </div>
        </div>
        <div class="form-group">
            <textarea class="form-control radius-0 font-13 edge-textarea brief-desc" placeholder="Brief description"
                [(ngModel)]="brief" maxlength="1000" [ngClass]="isBlankLong?'error-field':''" mwlResizable
                [enableGhostResize]="false" resizeCursorPrecision="100"
                [resizeEdges]="{bottom: true, right: false, top: false, left: false}" (resizeEnd)="onResizeEnd($event)"
                [style.height.px]="height"></textarea>
            <div class="warning-msg">
                *maximum 1000 characters
            </div>
        </div>
    </div>
</div>
<div class="row mar-lft-rgt-0">
    <div class="col-sm-6 pad-15 text-center">
        <app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName" [formData]="formdata"
            (uploadError)="onFileError($event)" (complete)="onFileComplete($event)" (dataLoaded)="onUpload($event)">
        </app-material-fileupload>
    </div>
    <div class="col-sm-6 pad-15 text-center upload-msg" [hidden]="hideAttachment">{{attachMsg}}
    </div>
</div>
<div class="row mar-lft-rgt-0" *ngIf="priorityType===1">
    <div class="col-sm-4 pad-15">
        <select class="custom-select" [(ngModel)]="impact" (change)="onImpactChange($event)">
            <option *ngFor="let map of impacts" [value]="map.id">{{map.name}}</option>
        </select>
    </div>
    <div class="col-sm-4 pad-15">
        <select class="custom-select" [(ngModel)]="urgency" (change)="onUrgencyChange($event)">
            <option *ngFor="let map of urgencies" [value]="map.id">{{map.name}}</option>
        </select>
    </div>
    <div class="col-sm-4 pad-15">
        <input class="form-control radius-0 font-13" type="text" [(ngModel)]="priority" placeholder="Priority" readonly>

    </div>
</div>
<div class="row mar-lft-rgt-0">
    <div class="col-sm-6 pad-15">
        <button type="button" class="btn btn-success btn-block radius-0 font-13" (click)="createTicket()">
            Create
        </button>
    </div>
    <div class="col-sm-6 pad-15">
        <button type="button" class="btn btn-success btn-block radius-0 font-13" (click)="resetField()">
            Reset
        </button>
    </div>
</div>



<notifier-container *ngIf="hideNotifier"></notifier-container>